import { render, staticRenderFns } from "./LotDuplicate.vue?vue&type=template&id=90fa0658&"
import script from "./LotDuplicate.vue?vue&type=script&lang=js&"
export * from "./LotDuplicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports